import { OPS_COMPANY_MEMBER_HEADERS } from '@/constants';
import { TableBody } from '@/ui';

import OpsMembersRow from './OpsMembersRow';

import type { CompanyMember } from '@/store/api/companyApi';

import Empty from '@/components/Company/Members/List/Empty';
import Loading from '@/components/Company/Members/List/Loading';
import { resolveViewerSessionZone } from '@/features/membersTable/viewerSessionTime';
import { useCompanySessions } from '@/hooks/useCompany';

interface OpsMembersListProps {
  companyId: string;
  isLoading?: boolean;
  isRefreshing?: boolean;
  members: CompanyMember[];
}

const OpsMembersList = ({
  companyId,
  isLoading = false,
  isRefreshing = false,
  members,
}: OpsMembersListProps) => {
  // Ideally this would happen in the Row/SessionColumn, and fetch count of sessions for each user
  // However, since member management is not paginated, this could trigger enough calls
  // to choke the browser. So we do it here, fetch all and send just what we need
  const { data: sessions = {}, isLoading: isLoadingSessions } =
    useCompanySessions(companyId);

  const viewerZone = resolveViewerSessionZone();

  const isActuallyLoading = isLoading || isLoadingSessions;

  if (isActuallyLoading) {
    return <Loading columns={OPS_COMPANY_MEMBER_HEADERS.length} />;
  }

  if (!members.length) {
    return <Empty columns={OPS_COMPANY_MEMBER_HEADERS.length} />;
  }

  return (
    <TableBody className={isRefreshing ? 'pointer-events-none opacity-50' : ''}>
      {members.map((member) => (
        <OpsMembersRow
          key={`${member.id}-ops-company-member`}
          companyId={companyId}
          sessionCount={sessions[member.id] || { done: 0, pending: 0 }}
          user={member}
          viewerZone={viewerZone}
        />
      ))}
    </TableBody>
  );
};

export default OpsMembersList;
